import { reduxKey } from './constants';
export const getPopover = (state, id)=>{
    const popover = (state[reduxKey] || []).find((item)=>item.id === id);
    if (popover) {
        return {
            isOpen: true,
            params: popover.options.params
        };
    } else {
        return {
            isOpen: false
        };
    }
};
